<template>
    <Component :is="sliceVariationComponent" v-bind="props" />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {getSliceComponentProps} from '@prismicio/vue';

    import type {FaqSlice} from '@prismicio-types';
    import FaqDefault from './variations/FaqDefault.vue';
    import {getSliceVariationComponent} from '../../utils/sliceVariations';

    const props = defineProps(getSliceComponentProps<FaqSlice>());

    const variationComponents = {
        default: FaqDefault,
    };

    const sliceVariationComponent = computed(() => getSliceVariationComponent(props.slice, variationComponents));
</script>
